export default __webpack_public_path__ + "static/media/gc-blue-black@2x.89ed9d5c.png";